import GeckoCalendar from "./";
import { $html, $each, $if } from "ekma";
import * as moment from "moment";

import Header from "./Header";
import Body from "./Body";
import EventSummary from "./EventSummary";

export default (calendar: GeckoCalendar) => $html`
	<div class="wrapper">
		${ calendar.getChild(Header, "$") }
		${ calendar.getChild(Body, "$") }
	</div>
	${ calendar.getChild(EventSummary, "$") }
`;